import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[520px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Beautiful%20Japanese%20sakura%20cherry%20blossom%20scenery%20with%20soft%20pink%20petals%20falling%20gently%2C%20warm%20spring%20sunlight%20filtering%20through%20branches%2C%20dreamy%20ethereal%20atmosphere%2C%20traditional%20Japanese%20aesthetic%2C%20soft%20focus%2C%20pastel%20pink%20and%20cream%20color%20palette%2C%20romantic%20and%20peaceful%20mood%2C%20subtle%20bokhe%20effect%2C%20high%20quality%20illustration%20style&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
        alt="樱花漫画网"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/40"></div>
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 tracking-wide">
          樱花漫画网
        </h1>
        <p className="text-sm md:text-lg text-white/80 max-w-xl mb-8 leading-relaxed">
          全集漫画大全 | 漫画全集免费完整版下拉式在线阅读<br />
          好看的韩漫日漫国漫全本漫画，一次看个够
        </p>
        <div className="flex items-center gap-3 flex-wrap justify-center">
          <Link
            to="/category/all"
            className="px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            开始阅读
            <span className="ml-1">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
          <Link
            to="/category/hanman"
            className="px-6 py-3 rounded-full bg-white/20 text-white font-medium text-sm hover:bg-white/30 transition-colors backdrop-blur-sm whitespace-nowrap"
          >
            热门韩漫
          </Link>
          <Link
            to="/category/riman"
            className="px-6 py-3 rounded-full bg-white/20 text-white font-medium text-sm hover:bg-white/30 transition-colors backdrop-blur-sm whitespace-nowrap"
          >
            经典日漫
          </Link>
        </div>
      </div>
    </section>
  );
}